export default __webpack_public_path__ + "static/media/foodbank_rewardUnlock.021796f2.png";